import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { BaseDtoService, IBaseDto } from './base-dto.service';
import { OrganizationClient, OrganizationDto } from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class OrganizationService extends BaseDtoService {
    constructor(private readonly client: OrganizationClient) {
        super();
    }

    async getAll(): Promise<OrganizationDto[]> {
        return await lastValueFrom(this.client.organizationGetForCurrentUser());
    }

    override getByIds(ids: number[]): Promise<IBaseDto[]> {
        throw new Error('Method not implemented.');
    }

    async getManagedOrganizations(): Promise<OrganizationDto[]> {
        return await lastValueFrom(this.client.organizationGetManagedOrganizationsForUser());
    }
}
